/* eslint-disable max-len */
import * as questionIds from "../../consultationQuestions/questionIds";

export const chesterStepQuestions = [{
    id: questionIds.ChesterStepUnableToCarryOutMedical,
    questionText: "Unable to carry out medical?"
}, {
    id: questionIds.ChesterStepUnableToCarryOutMedicalFurtherDetails,
    questionText: "Reason medical not carried out"
}, {
    id: questionIds.HasYourDoctorEverSaidThatYouHaveAHeartCondition,
    questionText: "Has your doctor ever said that you have a heart condition and that you should only do physical activity recommended by a doctor?"
}, {
    id: questionIds.DoYouFeelPainInYourChestWhenYouDoPhysicalActivities,
    questionText: "Do you feel pain in your chest when you do physical activities?"
}, {
    id: questionIds.InThePastMonthHaveYouHadChestPainWhenYouWereNotDoingPhysicalActivity,
    questionText: "In the past month, have you had chest pain when you were not doing physical activity?"
}, {
    id: questionIds.DoYouLoseYourBalanceBecauseOfDizzinessOrDoYouEverLoseConsciousness,
    questionText: "Do you lose your balance because of dizziness or do you ever lose consciousness?"
}, {
    id: questionIds.DoYouHaveABoneOrJointProblemThatCouldBeMadeWorseByAChangeInPhysicalActivity,
    questionText: "Do you have a bone or joint problem (for example, back, knee or hip) that could be made worse by a change in physical activity?"
}, {
    id: questionIds.IsYourDoctorCurrentlyPrescribingDrugsForBloodPressureOrAHeartCondition,
    questionText: "Is your doctor currently prescribing drugs (for example, water pills) for blood pressure or a heart condition?"
}, {
    id: questionIds.DoYouKnowOfAnyOtherReasonsWhyYouShouldNotDoPhysicalActivity,
    questionText: "Do you know of any other reasons why you should not do physical activity?"
}, {
    id: questionIds.DoYouSufferFromDiabetes,
    questionText: "Do you suffer from diabetes?"
}, {
    id: questionIds.DoYouSufferFromStomachOrIntestinalDisorders,
    questionText: "Do you suffer from stomach or intestinal disorders?"
}, {
    id: questionIds.IfYesToAnyAerobicFitnessAssessmentShouldBePostponed,
    questionText: "If a Yes is given to any question above, aerobic fitness assessment should be postponed and the individual referred for OHP assessment. Please write further comments here"
}, {
    id: questionIds.ChesterStepTypeOfTest,
    questionText: "Type of Test"
}, {
    id: questionIds.IsTheRoomQuietWellVentilatedAndBetween18To20DegreesCelsius,
    questionText: "Is the room quiet, well ventilated and between 18 to 20 degrees Celsius?"
}, {
    id: questionIds.IsThereEasyAccessToATelephoneOrHotlineForEmergencyMedicalServicesWithAGeographicDescriptionOfTheSiteAccessAndLocation,
    questionText: "Is there easy access to a telephone or ‘hotline’ for emergency medical services with a geographic description of the site access and location?"
}, {
    id: questionIds.HaveYouCheckedTheAutomatedExternalDefibrillatorIsChargedAndAvailable,
    questionText: "Have you checked the automated external defibrillator is charged and available?"
}, {
    id: questionIds.HaveYouHadTrainingInTheUseOfAnExternalAutomatedDefibrillator,
    questionText: "Have you had training in the use of an external automated defibrillator?"
}, {
    id: questionIds.HaveYouCheckedTheStepIsSecure,
    questionText: "Have you checked the step is secure?"
}, {
    id: questionIds.DoesTheHeartRateMonitorWork,
    questionText: "Does the heart rate monitor work?"
}, {
    id: questionIds.DoesTheMetronomeWork,
    questionText: "Does the metronome work?"
}, {
    id: questionIds.HaveYouHadBLSTraining,
    questionText: "Have you had BLS training?"
}, {
    id: questionIds.HaveYouCheckedThereAreNoContraIndicationsIdentified,
    questionText: "Have you checked there are no contra-indications identified?"
}, {
    id: questionIds.HaveTheySuitableWearingLooseFittingComfortableClothing,
    questionText: "Have they suitable wearing loose fitting, comfortable clothing?"
}, {
    id: questionIds.HaveYouCheckedThatTheSubjectHasNotEatenSmokedDrunkTeaOrCoffeeForAtLeastTwoHoursBeforeTheTest,
    questionText: "Have you checked that the subject has not eaten, smoked, drunk tea or coffee for at least two hours before the test?"
}, {
    id: questionIds.HaveYouBriefedThemOnTheTest,
    questionText: "Have you briefed them on the test?"
}, {
    id: questionIds.HaveYouCheckedThatTheSubjectIsNotSufferingFromAnyMuscularInjuryConditionWhichWillAffectHisHerAbility,
    questionText: "Have you checked that the subject is not suffering from any muscular injury condition or trauma which will affect his/her ability to carry out the exercise test safely?"
}, {
    id: questionIds.HaveYouCheckedTheSubjectIsNotRecoveringFromAnAcuteIllnessOrHasAColdOrIsTakingBetaBlockerDrugsWhichWillDepressHeartRateScores,
    questionText: "Have you checked the subject is not recovering from an acute illness or has a cold or is taking beta blocker drugs, which will depress heart rate scores?"
}, {
    id: questionIds.StepHeight,
    questionText: "Step height"
}, {
    id: questionIds.PulseBpm0Minutes,
    questionText: "Pulse (bpm) - 0 minutes"
}, {
    id: questionIds.PulseBpm2Minutes,
    questionText: "Pulse (bpm) - 2 minutes"
}, {
    id: questionIds.RPE2Minutes,
    questionText: "RPE"
}, {
    id: questionIds.PulseBpm4Minutes,
    questionText: "Pulse (bpm) - 4 minutes"
}, {
    id: questionIds.RPE4Minutes,
    questionText: "RPE"
}, {
    id: questionIds.PulseBpm6Minutes,
    questionText: "Pulse (bpm) - 6 minutes"
}, {
    id: questionIds.RPE6Minutes,
    questionText: "RPE"
}, {
    id: questionIds.PulseBpm8Minutes,
    questionText: "Pulse (bpm) - 8 minutes"
}, {
    id: questionIds.RPE8Minutes,
    questionText: "RPE"
}, {
    id: questionIds.PulseBpm10Minutes,
    questionText: "Pulse (bpm) - 10 minutes"
}, {
    id: questionIds.RPE10Minutes,
    questionText: "RPE"
}, {
    id: questionIds.ChesterStepAdditionalNotes,
    questionText: "Additional Notes"
}, {
    id: questionIds.ChesterStepNotes,
    questionText: "Notes"
}
];
